import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Rate route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} RateRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/rates",
        name: "Rates",
        meta: {
            title: "Rates",
            modules: ["rates"],
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(/* webpackChunkName: "rates" */ "@/views/rates/pages/Rates")
    },

    {
        path: "/rates/new",
        name: "NewRate",
        meta: {
            title: "New Rate",
            modules: ["rates"],
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(
            /* webpackChunkName: "rates" */ "@/views/rates/pages/NewRate"
            )
    },
    {
        path: `/rates/${idParam()}`,
        name: "RateDetails",
        meta: {
            title: "Rate Details",
            modules: ["rates"],
            requiresAuth: true,
            roles: [ROLES.SUPPLIER, ROLES.SUPPLIER_ACCESS, ROLES.DISPATCH]
        },
        component: () =>
            import(
            /* webpackChunkName: "rates" */ "@/views/rates/pages/RateDetails"
            )
    }
]